import { render, staticRenderFns } from "./FCDashboardNewAssignmentModal.vue?vue&type=template&id=1e668192&"
import script from "./FCDashboardNewAssignmentModal.vue?vue&type=script&lang=js&"
export * from "./FCDashboardNewAssignmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports